import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router, UrlSegment } from '@angular/router';

function isBrowserReload(): boolean {
  const doc = inject(DOCUMENT);
  const w = doc.defaultView;
  const perf = w?.performance;
  if (!perf) return false;

  const navEntries = perf.getEntriesByType?.('navigation') as
    | PerformanceNavigationTiming[]
    | undefined;
  const navType = navEntries?.[0]?.type ?? '';
  if (navType === 'reload') return true;

  // Legacy fallback
  const legacyType = (perf as unknown as { navigation?: { type?: number } }).navigation?.type ?? 0;
  return legacyType === 1;
}

function getConversationIdFromSegments(segments: UrlSegment[]): string {
  const last = segments[segments.length - 1];
  return (last?.path ?? '').trim();
}

export const pendingChatReloadRedirectGuard: CanMatchFn = (_route, segments) => {
  const router = inject(Router);

  // Only act on the initial, bootstrap-time navigation.
  if (router.navigated) return true;

  const conversationId = getConversationIdFromSegments(segments);
  if (!conversationId.startsWith('pending_')) return true;

  // Only redirect when the browser navigation type is a tab reload/refresh.
  if (!isBrowserReload()) return true;

  return new RedirectCommand(router.parseUrl('/app'), { replaceUrl: true });
};
